
























import { Prop, Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { SwScrollView } from '@sonicwall/unified-ui-framework/src/shared/sw-scroll-view';
import { SwTitlePane } from '@sonicwall/unified-ui-framework/src/shared/sw-title-pane';
// import { InfoState } from '@/core';

const cssPrefix = 'releaseHelpDialog';
@Component({
  components: {
    ...UUIFComponent,
    SwScrollView,
    SwTitlePane,
  },
})

export default class ReleaseHelpDialog extends SwExtendedVue {
  @Prop()
  releaseHelpModal: boolean;
  cssPrefix = cssPrefix;
  helpObj = [
    {
      title: this.$t('myDownloadInfo.subTitles.generalRelease')
        .toString(),
      desc: this.$t('myDownloadInfo.desc.generalReleaseI')
        .toString(),
    },
    {
      title: this.$t('myDownloadInfo.subTitles.featureRelease')
        .toString(),
      desc: this.$t('myDownloadInfo.desc.featureReleaseI')
        .toString(),
    },
    {
      title: this.$t('myDownloadInfo.subTitles.maintenanceRelease')
        .toString(),
      desc: this.$t('myDownloadInfo.desc.maintenanceReleaseI')
        .toString(),
    },
    {
      title: this.$t('myDownloadInfo.subTitles.earlyRelease')
        .toString(),
      desc: this.$t('myDownloadInfo.desc.earlyReleaseI')
        .toString(),
    },
    {
      title: this.$t('myDownloadInfo.subTitles.initialRelease')
        .toString(),
      desc: this.$t('myDownloadInfo.desc.initialReleaseI')
        .toString(),
    },
    {
      title: this.$t('myDownloadInfo.subTitles.hotfixRelease')
        .toString(),
      desc: this.$t('myDownloadInfo.desc.hotfixReleaseI')
        .toString(),
    },
  ];

  closeDialog(value:boolean = false) {
    this.$emit('closeReleaseHelpDialog', value);
  }

  created() {
    // this.title = this.$t('myDownloadInfo.maintitle')
    //                   .toString();
    // const titlesObj = this.$t('myDownloadInfo.subTitles');
    // const titleList = Object.values(titlesObj);
    // const descObj = this.$t('myDownloadInfo.desc');
    // const descList = Object.values(descObj);
    // titleList.forEach((titl:any, index:number) => {
    //   // this.helpObj.push({ title: (titl as String), desc: (descList[index] as String) });
    //    // tslint:disable-next-line
    //   this.helpObj.map((hobj:any) => {
    //     return {
    //       title: (titl as String),
    //       desc: (descList[index] as String),
    //     };
    //   });
    // });
  }
}
